import "./index.scss";
import "../../locales/i18n";

import React from "react";
import { useTranslation } from "react-i18next";

import Badge from "@/components/components/Badge";
import { BadgeColor } from "@/components/components/Badge/badgeColor.enum";
import { SimpleDropdown } from "@/components/components/Dropdown";
import { OptionVariant } from "@/components/components/Dropdown/dropdown.enum";
import { TDropdownOption } from "@/components/components/Dropdown/dropdown.type";
import { H2 } from "@/components/components/Headings/H";
//import Caret from "@/components/icons/Caret";
import { ConversationCategory } from "@/messenger/types/entities/conversation";
import ChatStatusOptionSelectedMobile from "../ChatStatusDropdownSelectedOptionMobile";
import StatusLoading from "../StatusLoading";

export interface MobileChatHeaderProp {
    category: ConversationCategory;
    disabled?: boolean;
    nextCategories: ConversationCategory[];
    name: string;
    options: TDropdownOption[];
    heading?: string;
    selectedOption: TDropdownOption;
    loading: boolean;
    onSelect: (o: TDropdownOption) => void;
    isInbound: boolean;
    currentCategory: string;
}

const MobileChatHeader = ({ category, nextCategories, name, options, onSelect, isInbound, selectedOption, loading, heading, disabled, currentCategory }: MobileChatHeaderProp) => {
    const baseClassName = "c-mobile-chat-header";
    const actionableCategories = [ConversationCategory.OPEN, ConversationCategory.TO_ANSWER, ConversationCategory.TO_BE_CONTACTED, ConversationCategory.CLOSED];

    const { t } = useTranslation();

    const showCaret = actionableCategories.includes(category);
   
    const renderHeaderTitle = () => (
        <div className={`${baseClassName}__container`}>
            <div className={`${baseClassName}__title`}>
                <H2 className={`${baseClassName}__contact`} style={{ flex: "1", marginRight: "3px" }}>
                    {name}
                </H2> 
                {isInbound && <Badge color={BadgeColor.MAIN}><span>Inbound</span></Badge>}
            </div>
        </div>
    );
    
    const renderOverride = (_, toggleMenu: () => void) => <ChatStatusOptionSelectedMobile
        label={selectedOption?.label}
        heading={heading || "Status"}
        value={selectedOption?.heading}
        showCaret={options?.length > 0}
        disabled={disabled}
        toggleMenu={toggleMenu}
    />;

    return (
        <>
            {renderHeaderTitle()}
            <div className={`${baseClassName}__mobile-status-loading`}>
                {
                    loading ? <StatusLoading category={currentCategory} isMobile={true} /> :
                    <SimpleDropdown
                        disabled={!showCaret}
                        dropdownDefaultRenderClassNames={{}}
                        heading={t("Select Status")}
                        isMobileView={true}
                        onSelect={onSelect}
                        options={options}
                        optionsVariant={OptionVariant.ACCENTED}
                        renderOverride={renderOverride}
                        search={false}
                        selectedOption={null}
                    />
                }
            </div>
        </>
    );
};

export default MobileChatHeader;